import { ICategory, ISkill } from '@wot/typings';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import categoryApi from '../../../api/categories';
import { MORE_SVG } from '../../../assets/icons';
import LoadingContent from '../../../components/LoadingContent';
import NoResults from '../../../components/NoResults';
import { TableBody, TableHeading, TableHeadingCol, TableRow, TableRowItemData } from '../../../components/Table';
import { Dropdown } from '@wot/components';
import { DropDownItem } from '../../../components/DropDown';

export function Skill() {
  const [data, setData] = useState<ICategory<ISkill>[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    try {
      categoryApi
        .getCategories('skill')
        .then((data) => {
          setData(data);
          setLoading(false);
        })
        .catch((err) => err);
    } catch (err) {
      setLoading(false);
    }
  }, []);

  return (
    <>
      <div className="w-full flex items-center justify-between my-4 p-4 bg-[#F4F7FCBF] ">
        <div className="flex items-center gap-4">
          {/* <Search />
          <Filter /> */}
        </div>
        <div className="flex items-center gap-4">
          <Link to="/general-management/categories/addSkill">
            <button className="w-max px-4 py-2 bg-secondary text-white text-sm rounded-full cursor-pointer">
              + Add Skill
            </button>
          </Link>
          {/* <MoreActions /> */}
        </div>
      </div>

      <div className="flex flex-col">
        <div className="w-full flex flex-col grow custom-scrollbar">
          <div className="w-full h-full custom-scrollbar">
            {loading ? (
              <LoadingContent />
            ) : data.length === 0 ? (
              <NoResults />
            ) : (
              <table className="min-w-full table-fixed">
                <TableHeading>
                  <TableRow>
                    <TableHeadingCol label="#" />
                    <TableHeadingCol label="Date" />
                    <TableHeadingCol label="ID" />
                    <TableHeadingCol label="Name" />
                    <TableHeadingCol label="Levels" />
                    <TableHeadingCol label="" />
                  </TableRow>
                </TableHeading>
                <TableBody>
                  {data.map((item, index) => (
                    <TableRow key={index}>
                      <TableRowItemData text={(index + 1).toString()} />
                      <TableRowItemData text={`${dayjs(item.createdAt).format('DD/MM/YYYY')}`} />
                      <TableRowItemData text={item._id} />
                      <TableRowItemData text={item.category.name} />
                      <TableRowItemData text={item.category.levels?.toString()} />
                      <TableRowItemData
                        component={
                          <Dropdown
                            menu={[
                              {
                                key: 1,
                                label: <DropDownItem label="Edit" onClick={() => navigate(`${item._id}`)} />
                              }
                            ]}
                          >
                            <div className="w-full h-full px-4 py-2 flex items-center justify-end cursor-pointer">
                              <img src={MORE_SVG} className="h-4" alt="More options" />
                            </div>
                          </Dropdown>
                        }
                      />
                    </TableRow>
                  ))}
                </TableBody>
              </table>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
